export const REQUIRED_FIELD = 'intake.yup.required'
export const REQUIRED_DOCUMENT = 'intake.documents.required'
export const REQUIRED_INCOME = 'intake.income.required'
export const ERROR_DOCUMENT_UPLOADING = 'system.file.is.uploading'
export const ERROR_INCOME_OVER_ONE = 'intake.income.over.one'
export const ERROR_DATE_NOT_IN_PAST = 'intake.rent.intention.date.error.not.in.past'
export const REQUIRED_DATE = 'intake.rent.intention.date.error'
export const ERROR_INVALID_EMAIL = 'error.invalid.email'
export const ERROR_INVALID_PHONE_NUMBER = 'error.invalid.phone.number'
export const ERROR_PASSWORD_REGEX = 'system.password.invalid.regex'
export const ERROR_NOT_A_NUMBER = 'system.not.a.number'
export const ERROR_IN_GOOD_CONSCIENCE = 'intake.financial.in_good_conscience.error'
export const ERROR_INCOME_STATEMENT = 'intake.financial.income_statement.error'
export const ERROR_ACCEPT_DATA_USAGE = 'overview.accept.datausage.error'
export const ERROR_APPLICATION_ACCEPT_DATA_USAGE = 'application.accept.data_usage.error'
export const FINANCIAL_REMARKS_MAX_LENGTH = 1000
export const MAX_FILE_SIZE = 30



// WEBPACK FOOTER //
// ./src/utils/validation/constants.js